export default __webpack_public_path__ + "static/media/rocket.c3140172.svg";